import { DecryptedPatient } from '@icure/cardinal-sdk'
import { Alert, Form } from 'antd'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useSharePatientWithMutation } from '../../../../../core/api/patientApi'
import { CustomModal } from '../../../../common/CustomModal'
import './index.less'
import { PractitionersSelect } from './PractitionersSelect'
import { SpinLoader } from '../../../../common/SpinLoader'

interface ModalPatientFormProps {
  isVisible: boolean
  onClose: () => void
  patientToEdit: DecryptedPatient
}

export const ModalSharePatient = ({ isVisible, onClose, patientToEdit }: ModalPatientFormProps): ReactElement => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const [sharePatient, { error: sharePatientError, isError: isSharePatientError, isLoading: isSharePatientLoading }] = useSharePatientWithMutation()

  if (isSharePatientError) console.error(sharePatientError)

  const handleOnClose = () => {
    form.resetFields()
    onClose()
  }

  const handleOnOk = (values: { selectedDoctors: { value: string; label: string }[] }) => {
    if (values.selectedDoctors !== undefined) {
      values.selectedDoctors.map((el) =>
        sharePatient({
          patient: new DecryptedPatient(patientToEdit),
          delegateId: el.value,
        }),
      )
    }

    form.resetFields()
    onClose()
  }

  return (
    <CustomModal
      isVisible={isVisible}
      handleClose={handleOnClose}
      secondaryBtnTitle={t('buttons.cancel')}
      handleClickPrimaryBtn={() => form.submit()}
      primaryBtnTitle={t('buttons.save')}
      title={t('patients.actions.share')}
    >
      <div className="modalSharePatient">
        {isSharePatientLoading && <SpinLoader />}
        <Form className="modalSharePatient__form" layout="vertical" colon={false} form={form} onFinish={(values) => handleOnOk(values)}>
          <Alert showIcon={true} message={t('patients.actions.shareModalAlert')} />
          <div className="modalSharePatient__form__inputs">
            <Form.Item name="selectedDoctors" label={t('patients.actions.selectHealthcareProfessionals')}>
              <PractitionersSelect />
            </Form.Item>
          </div>
        </Form>
      </div>
    </CustomModal>
  )
}
